import React from "react";
import { useTranslation } from "react-i18next";
import img1 from '../../assets/new images/personalized.png';
import img2 from '../../assets/new images/AiCareer.png';
import img3 from '../../assets/new images/Global.png';

const WhyCabil = () => {
  const { t } = useTranslation();

  const features = [
    { title: t("whyCabil.personalised"), desc: t("whyCabil.personalisedDesc"), icon: img1 },
    { title: t("whyCabil.aiInsights"), desc: t("whyCabil.aiInsightsDesc"), icon: img2 },
    { title: t("whyCabil.global"), desc: t("whyCabil.globalDesc"), icon: img3 },
  ];

  return (
    <section className="py-20 bg-gray-50 text-center">
      <h2 className="text-5xl font-bold text-gray-800 mb-8">{t("whyCabil.title")}</h2>
      <p className="max-w-2xl mx-auto text-center text-gray-600 mb-12">
        {t("whyCabil.subtitle")}
      </p>
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {features.map((f, i) => (
          <div key={i} className="bg-white flex flex-col gap-2 justify-center items-center p-8 shadow rounded-xl border hover:border-orange-500 hover:shadow-xl hover:shadow-orange-500/20 transition group">
            <img src={f.icon} alt="" className="w-16 h-16 transition group-hover:shadow-xl group-hover:shadow-orange-500/30 rounded-2xl bg-transparent"/>
            <h3 className="font-semibold text-xl mb-2">{f.title}</h3>
            <p className="text-gray-600">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyCabil;
